import React from "react";
import { NavLink } from "react-router-dom";
import { useAuth } from "../auth/AuthContext.jsx";
import { BRAND_LOGO, BRAND_LOGO_INVERT, BRAND_NAME } from "../brand.js";

// The 232px sidebar this replaces spent that width on six links. The Spend
// page needs it back — three drill panes side by side is what makes the
// account -> service -> resource path fit on one screen — so navigation moved
// into the header and the six pages collapsed into four destinations.
//
// Trend is not part of the Spend consolidation and keeps its own page, so it
// keeps a nav entry; dropping it would leave a working page unreachable.
const links = [
  { to: "/summary", label: "Summary" },
  { to: "/spend", label: "Spend details" },
  { to: "/savings", label: "Savings" },
  { to: "/trend", label: "Trend" },
  { to: "/invoices", label: "Invoices" },
  { to: "/accounts", label: "Accounts" },
];

/**
 * The app's top bar. `children` is the page's own right-hand slot — the Spend
 * page puts its freshness stamp and Refresh button there; other pages leave
 * it empty.
 */
export default function AppHeader({ title = "Cost & Usage", children }) {
  const { claims, logout } = useAuth();

  return (
    <header className="app-header">
      {BRAND_LOGO ? (
        <img src={BRAND_LOGO} alt={BRAND_NAME} className={`app-header-logo${BRAND_LOGO_INVERT ? " logo-invert" : ""}`} />
      ) : (
        <span className="app-header-wordmark">{BRAND_NAME}</span>
      )}
      <span className="app-header-rule" aria-hidden="true" />
      <h1 className="app-header-title">{title}</h1>
      <nav className="app-header-nav" aria-label="Primary">
        {links.map((l) => (
          <NavLink key={l.to} to={l.to}>
            {l.label}
          </NavLink>
        ))}
      </nav>
      <div className="app-header-right">
        {children}
        <div className="app-header-user">
          <span className="app-header-user-email" title={claims?.email}>
            {claims?.email}
          </span>
          <button type="button" className="ghost" onClick={logout} title={claims?.email ? `Signed in as ${claims.email}` : undefined}>
            Sign out
          </button>
        </div>
      </div>
    </header>
  );
}
